import { createApiClient } from '@akillidernek/api-client'
import { getAccessToken, setAccessToken } from './auth-store'
import { getTenantSlug } from './tenant'

/** Tek istemci. Aynı origin: Vite `/api`yi API'ye vekiller, üretimde aynı alan adı. */
export const api = createApiClient({
  getTenantSlug,
  getAccessToken,
  onUnauthenticated: () => setAccessToken(null),
})

/** Sayfa açılışında oturumu httpOnly yenileme çerezinden geri kurar. */
export async function bootstrapSession(): Promise<boolean> {
  try {
    const { data } = await api.POST('/api/v1/auth/refresh')
    if (data?.access_token) {
      setAccessToken(data.access_token)
      return true
    }
  } catch {
    // Oturum yok.
  }
  return false
}
